import { useOpenCommandCenterOnKeyPress } from 'client/modules/commandCenter/hooks/useOpenCommandCenterOnKeyPress';

export function OpenCommandCenterOnKeyPressListener() {
  useOpenCommandCenterOnKeyPress();

  return null;
}
